import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import styled, { keyframes } from "styled-components";
import { Formik } from "formik";
import "react-toastify/dist/ReactToastify.css";
import "../../../store/Layout/style/product.css";
import {
  getApprover,
  getApprovers,
  getFee,
  sendCustomOffer,
} from "../../../utils/services/user.service";
import { CustomSelect } from "../CustomSelect";
import { toast } from "react-toastify";
import { Ring } from "@uiball/loaders";

const CustomOfferModal = ({
  showModal,
  closeModal,
  product,
  SelectedColor,
}) => {

  const history = useHistory();
  const [cartData, setCartData] = useState([]);
  const [customOfferPrice, setCustomOfferPrice] = useState(null);
  const [Countries, setCountries] = useState([
    { label: "United States", value: "United States" },
    { label: "United Kingdom", value: "United Kingdom" },
    { label: "Germany", value: "Germany" },
    { label: "France", value: "France" },
  ]);
  const [setDeliveryCharges, setDeliveryChargesTotal] = useState(0);
  const [cartSybmol, setCartSybmol] = useState("");
  const [saleTaxFee, setSaleTaxFee] = useState(0);
  const [Approvers, setApprovers] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState();
  const [showError1, setShowError1] = useState(false);
  const [getApproverID, setApproverID] = useState("");
  const [deliveryAddress, setDeliveryAddress] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  let countriesArray = [];
  let dataArray = [];
  let total1 = 0;

  useEffect(() => {
    fetch("https://restcountries.com/v3.1/all")
      .then((response) => response.json())
      .then((data) => {
        // Extract specific data and store it in the countriesArray
        // eslint-disable-next-line react-hooks/exhaustive-deps
        countriesArray = data.map((country) => ({
          label: country.name.common,
          value: country.name.common,
        }));

        // Now you have the data in the countriesArray
        setCountries(countriesArray);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
    const userAdress = JSON.parse(localStorage.getItem("user"));
    let storedCustomArray = [];
    let parsedCustomArray = [];
    if (localStorage.getItem("customArray") != null) {
      storedCustomArray = localStorage.getItem("customArray");
      parsedCustomArray = JSON.parse(storedCustomArray);
    }
    parsedCustomArray = parsedCustomArray.filter(
      (item) => item.userId === userAdress.data.user.user_id
    );
    setCartData(parsedCustomArray);
    if (parsedCustomArray.length > 0) {
      setCartSybmol(parsedCustomArray[0].symbol);
    }

    // const calculateUpdatedPrice = (price, quantity) => price * quantity;
    // console.log('calculateUpdatedPrice', calculateUpdatedPrice);

    if (parsedCustomArray != null) {
      parsedCustomArray.forEach((data) => {
        const itemTotal = data.deliveryCharges;
        // eslint-disable-next-line react-hooks/exhaustive-deps
        total1 += itemTotal;
      });
      setDeliveryChargesTotal(total1);
    }
  }, []);

  const approverOptions = Approvers.map((approver) => ({
    value: approver.address,
    label: approver.name,
  }));
  const handleCountryChange = (value) => {
    setSelectedCountry(value.value);
    setShowError1(false);
  };
  const handleApproverChange = (event) => {
    const selectedID = event.value;
    setApproverID(selectedID);
  };
  const handleDeliveryAddressChange = (e) => {
    setDeliveryAddress(e.target.value);
  };

  const fetchgetFee = async () => {
    try {
      const requestData = {
        type: "sale_tax",
        categoryId: product?.category_id,
      };
      const response = await getFee(requestData);

      if (response.data) {
        const saleTaxFee = response?.data?.data?.fee;
        setSaleTaxFee(saleTaxFee);
      } else {
        console.error("getFee:", response.statusText);
      }
    } catch (error) {
      setSaleTaxFee(0);
    }
  };

  useEffect(() => {
    if (product) {
      fetchgetFee();
    }
  }, [product]);

  useEffect(() => {
    fetch("https://restcountries.com/v3.1/all")
      .then((response) => response.json())
      .then((data) => {
        // Extract specific data and store it in the countriesArray
        // eslint-disable-next-line react-hooks/exhaustive-deps
        countriesArray = data.map((country) => ({
          label: country.name.common,
          value: country.name.common,
        }));

        // Now you have the data in the countriesArray
        setCountries(countriesArray);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });

    const fetchgetApprovers = async () => {
      try {
        const response = await getApprovers(); // Replace with your API call for approvers
        if (response.data && response.data.user.length > 0) {
          const approverInfo = response.data.user; // Extract the first approver
          approverInfo.sort((a, b) => a.name.localeCompare(b.name));
          setApprovers(approverInfo);
        } else {
          console.error("Error fetching approver data:", response.statusText);
        }
      } catch (error) {
        console.error("Error fetching approver data:", error);
      }
    };

    fetchgetApprovers();
  }, []);

  const originalPrice = product?.product_sizes_quantity[0]?.price;
  const discountPercentage = product?.product_sizes_quantity[0]?.discount || 0
  const discountedPrice =
    originalPrice - originalPrice * (discountPercentage / 100);

  const handleSendCustomOffer = async () => {
    try {
      setIsLoading(true);
      const payload = {
        symbol: product.symbol,
        total_delivery_charges: product.deliveryCharges,
        chain_id: product?.chainId,
        store_id: product?.store_id,
        category_id: product?.category_id,
        custom_offer_amount: customOfferPrice,
        orignal_price: product?.product_sizes_quantity[0]?.price,
        total_quantity: 1,
        delivery_country: selectedCountry,
        delivery_address: deliveryAddress,
        seller_user_id: product?.userId,
        product_details: product?.product_sizes_quantity,
        approver_wallet_Address: product?.approver_wallet_Address,
        buyer_approver_address: getApproverID,
        product_id: product?._id,
        sale_tax: saleTaxFee,
        seller_wallet: product?.seller_name[0]?.address,
        agency_percentage: product?.agency_percentage,
      };
      const res = await sendCustomOffer(payload);
      if (res) {
        toast.success(res?.data?.Message);
        setIsLoading(false);
        closeModal();
      }
    } catch (error) {
      toast.error(error?.response?.data.Message);
      setIsLoading(false);
      // You can handle the error here, e.g., show a message to the user
    }
  };

  if (!product) {
    return (
      <div className="container mt-4 containerDiv">
        <div className="row">
          <div className="col-12 text-center">
            {" "}
            <h1 className="text-white"> No Product Found</h1>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      {showModal && (
        <>
          <ModalOverlay onClick={closeModal} />
          <ModalContainer>
            <ModalHeader>
              <ModalTitle>SEND CUSTOM OFFER</ModalTitle>
              <CloseButton onClick={closeModal}>×</CloseButton>
            </ModalHeader>
            <ModalBody>
              {isLoading && (
                <LoadingOverlay>
                  <Ring size={65} color="#00f7d2" />
                </LoadingOverlay>
              )}
              <Formik
                enableReinitialize
                initialValues={{
                  quantity: 1,
                  pickupAddress: "",
                  price: "",
                }}
                onSubmit={(values) => {
                  handleSendCustomOffer();
                }}
              >
                {(props) => {
                  const { handleSubmit } = props;

                  return (
                    <Form onSubmit={handleSubmit}>
                      <ProductTableContainer>
                        <ProductTable>
                          <thead>
                            <tr>
                              <TableHeader>Image</TableHeader>
                              <TableHeader>Name</TableHeader>
                              <TableHeader>Color</TableHeader>
                              <TableHeader>Quantity</TableHeader>
                              <TableHeader>Price</TableHeader>
                              <TableHeader>Discount</TableHeader>
                              <TableHeader>After Discount</TableHeader>
                              <TableHeader>Shipping</TableHeader>
                            </tr>
                          </thead>
                          <tbody>
                            {product.length === 0 ? (
                              <tr>
                                <TableData colSpan="8" style={{ textAlign: "center", padding: "20px" }}>
                                  No Product Available in Cart
                                </TableData>
                              </tr>
                            ) : (
                              <tr>
                                <TableData style={{ width: "8%" }}>
                                  <ProductImage src={product?.pictures[0]} alt="product" />
                                </TableData>
                                <TableData style={{ textTransform: "capitalize" }}>
                                  {product.title}
                                </TableData>
                                <TableData>
                                  {SelectedColor || "-"}
                                </TableData>
                                <TableData style={{ textAlign: "center" }}>
                                  <QuantityText>1</QuantityText>
                                </TableData>
                                <TableData>
                                  {originalPrice} {product.symbol}
                                  {product?.network_name ? ` (${product.network_name})` : product?.chainDetails?.network_name ? ` (${product.chainDetails.network_name})` : ''}
                                </TableData>
                                <TableData>
                                  {discountPercentage}%
                                </TableData>
                                <TableData>
                                  {discountedPrice} {product.symbol}
                                </TableData>
                                <TableData>
                                  {product.deliveryCharges} {product.symbol}
                                </TableData>
                              </tr>
                            )}
                          </tbody>
                        </ProductTable>
                      </ProductTableContainer>

                      <FormRow>
                        <FormColumn>
                          <Label>Delivery Country *</Label>
                          <CustomSelect
                            name="deliveryCountry"
                            id="deliveryCountry"
                            value={selectedCountry}
                            onChange={handleCountryChange}
                            options={Countries}
                          />
                        </FormColumn>
                        <FormColumn>
                          <Label>Buyer Approver</Label>
                          <CustomSelect
                            name="subcategory_id"
                            id="subcategory_id"
                            styles={{
                              menu: (provided) => ({
                                ...provided,
                                textTransform: "capitalize",
                              }),
                            }}
                            value={getApproverID}
                            options={approverOptions}
                            onChange={handleApproverChange}
                          />
                        </FormColumn>
                        <FormColumn>
                          <Label>Delivery Address *</Label>
                          <StyledInput
                            type="text"
                            placeholder="Enter Delivery Address"
                            name="deliveryAddress"
                            id="deliveryAddress"
                            value={deliveryAddress}
                            onChange={handleDeliveryAddressChange}
                          />
                        </FormColumn>
                      </FormRow>

                      <SummaryContainer>
                        <SummaryTitle>Custom Offer</SummaryTitle>
                        <SummaryRow>
                          <SummaryLabel>Custom offer Price</SummaryLabel>
                          <SummaryInput
                            type="number"
                            value={customOfferPrice}
                            placeholder="Custom offer Price"
                            onChange={(e) => setCustomOfferPrice(e.target.value)}
                          />
                        </SummaryRow>
                        <SummaryRow>
                          <SummaryLabel>Total Quantity</SummaryLabel>
                          <SummaryValue>1</SummaryValue>
                        </SummaryRow>
                        <SummaryRow>
                          <SummaryLabel>Shipping Charges</SummaryLabel>
                          <SummaryValue>
                            {product.deliveryCharges} {product.symbol}
                          </SummaryValue>
                        </SummaryRow>
                        <SummaryRow>
                          <SummaryLabel>Sales Tax</SummaryLabel>
                          <SummaryValue>
                            {saleTaxFee} {product.symbol}
                          </SummaryValue>
                        </SummaryRow>
                        <SummaryRow>
                          <SummaryLabel>Grand Total</SummaryLabel>
                          <GrandTotal>
                            {Number(customOfferPrice || 0) + Number(product.deliveryCharges || 0) + Number(saleTaxFee || 0)} {product.symbol}
                          </GrandTotal>
                        </SummaryRow>
                        <SubmitButton
                          type="submit"
                          disabled={
                            !customOfferPrice ||
                            customOfferPrice <= 0 ||
                            !selectedCountry ||
                            !deliveryAddress ||
                            isLoading
                          }
                        >
                          Send Custom Offer
                        </SubmitButton>
                      </SummaryContainer>
                    </Form>
                  );
                }}
              </Formik>
            </ModalBody>
          </ModalContainer>
        </>
      )}
    </>
  );
};
export default CustomOfferModal;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const slideUp = keyframes`
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.75);
  z-index: 999;
  animation: ${fadeIn} 0.2s ease;
`;

const ModalContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 1200px;
  max-height: 90vh;
  background: #0d1220;
  border: 1px solid #1f2937;
  border-radius: 16px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: ${slideUp} 0.3s ease;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
`;

const ModalHeader = styled.div`
  padding: 20px 24px;
  border-bottom: 1px solid #1f2937;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #0d1220;
`;

const ModalTitle = styled.h2`
  font-size: 18px;
  font-weight: 700;
  color: #e5e7eb;
  margin: 0;
  letter-spacing: 0.5px;
`;

const CloseButton = styled.button`
  background: transparent;
  border: none;
  color: #9ca3af;
  font-size: 28px;
  line-height: 1;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.05);
    color: #e5e7eb;
  }
`;

const ModalBody = styled.div`
  padding: 24px;
  overflow-y: auto;
  flex: 1;
  position: relative;
`;

const LoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(13, 18, 32, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: 16px;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const ProductTableContainer = styled.div`
  overflow-x: auto;
  border-radius: 12px;
  border: 1px solid #1f2937;
  background: #0d1220;
`;

const ProductTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: #0d1220;
`;

const TableHeader = styled.th`
  padding: 14px 12px;
  text-align: left;
  font-size: 13px;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 1px solid #1f2937;
  background: rgba(31, 41, 55, 0.3);
`;

const TableData = styled.td`
  padding: 14px 12px;
  font-size: 14px;
  color: #e5e7eb;
  border-bottom: 1px solid #1f2937;
  vertical-align: middle;
`;

const ProductImage = styled.img`
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid #1f2937;
`;

const QuantityText = styled.span`
  color: #9ca3af;
  font-weight: 500;
`;

const FormRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const FormColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Label = styled.label`
  font-size: 13px;
  font-weight: 500;
  color: #e5e7eb;
  margin-bottom: 4px;
`;

const StyledInput = styled.input`
  width: 100%;
  padding: 12px 14px;
  background: rgba(31, 41, 55, 0.3);
  border: 1px solid #1f2937;
  border-radius: 10px;
  color: #e5e7eb;
  font-size: 14px;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: #5ce9ff;
    background: rgba(31, 41, 55, 0.5);
    box-shadow: 0 0 0 3px rgba(92, 233, 255, 0.1);
  }

  &::placeholder {
    color: #6b7280;
  }
`;

const SummaryContainer = styled.div`
  background: rgba(31, 41, 55, 0.3);
  border: 1px solid #1f2937;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 400px;
  margin-left: auto;

  @media (max-width: 768px) {
    max-width: 100%;
    margin-left: 0;
  }
`;

const SummaryTitle = styled.h3`
  font-size: 16px;
  font-weight: 700;
  color: #e5e7eb;
  margin: 0 0 8px 0;
  padding-bottom: 12px;
  border-bottom: 1px solid #1f2937;
`;

const SummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`;

const SummaryLabel = styled.label`
  font-size: 13px;
  color: #9ca3af;
  font-weight: 500;
`;

const SummaryInput = styled.input`
  flex: 1;
  padding: 10px 12px;
  background: rgba(31, 41, 55, 0.5);
  border: 1px solid #1f2937;
  border-radius: 8px;
  color: #e5e7eb;
  font-size: 14px;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: #5ce9ff;
    background: rgba(31, 41, 55, 0.7);
    box-shadow: 0 0 0 3px rgba(92, 233, 255, 0.1);
  }

  &::placeholder {
    color: #6b7280;
  }
`;

const SummaryValue = styled.span`
  font-size: 14px;
  color: #e5e7eb;
  font-weight: 500;
`;

const GrandTotal = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: #5ce9ff;
`;

const SubmitButton = styled.button`
  width: 100%;
  padding: 14px 20px;
  background: linear-gradient(135deg, #00f7d2 0%, #5ce9ff 100%);
  border: none;
  border-radius: 10px;
  color: #000;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 8px;

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 247, 210, 0.3);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background: rgba(255, 255, 255, 0.1);
    color: #9ca3af;
  }
`;